export default "__VITE_PUBLIC_ASSET__fe12810c__"